import BuildBusinessUnitDetailPage from "../pages/build/BuildBusinessUnitDetailPage";
import BuildDepartmentListPage from "../pages/build/BuildDepartmentListPage";
import BuildDepartmentDetailPage from "../pages/build/BuildDepartmentDetailPage";
import BuildDepartmentMemberListPage from "../pages/build/BuildDepartmentMemberListPage";
import BuildDepartmentMemberAssignPage from "../pages/build/BuildDepartmentMemberAssignPage";
import BuildDepartmentMemberDetailPage from "../pages/build/BuildDepartmentMemberDetailPage";
import BuildDepartmentMemberMoveCompanyPage from "../pages/build/BuildDepartmentMemberMoveCompanyPage";
import BuildDepartmentMemberMoveMarketPage from "../pages/build/BuildDepartmentMemberMoveMarketPage";
import BuildDepartmentApplicationListPage from "../pages/build/BuildDepartmentApplicationListPage";
import BuildDepartmentApplicationAssignPage from "../pages/build/BuildDepartmentApplicationAssignPage";
import BuildDepartmentPartnerListPage from "../pages/build/BuildDepartmentPartnerListPage";
import BuildDepartmentPartnerAssignPage from "../pages/build/BuildDepartmentPartnerAssignPage";
import BuildDepartmentActionListPage from "../pages/build/BuildDepartmentActionListPage";
import BuildDepartmentActionCreatePage from "../pages/build/BuildDepartmentActionCreatePage";
import BuildDepartmentActionDetailPage from "../pages/build/BuildDepartmentActionDetailPage";
import BuildProjectListPage from "../pages/build/BuildProjectListPage";
import BuildProjectDetailPage from "../pages/build/BuildProjectDetailPage";
import BuildProjectMemberListPage from "../pages/build/BuildProjectMemberListPage";
import BuildProjectMemberDetailPage from "../pages/build/BuildProjectMemberDetailPage";
import BuildProjectMemberAssignPage from "../pages/build/BuildProjectMemberAssignPage";
import BuildProjectGoalAchievementListPage from "../pages/build/BuildProjectGoalAchievementListPage";
import BuildProgramListPage from "../pages/build/BuildProgramListPage";
import BuildProgramDetailPage from "../pages/build/BuildProgramDetailPage";
import BuildProgramMemberListPage from "../pages/build/BuildProgramMemberListPage";
import BuildProgramMemberDetailPage from "../pages/build/BuildProgramMemberDetailPage";
import BuildProgramMemberAssignPage from "../pages/build/BuildProgramMemberAssignPage";
import BuildProgramGoalAchievementListPage from "../pages/build/BuildProgramGoalAchievementListPage";

const buildRoutes = [
  // ── BusinessUnit ──
  {
    path: ":businessDomainId/business-units/:businessUnitId",
    element: <BuildBusinessUnitDetailPage />,
  },

  // ── Project ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/projects",
    element: <BuildProjectListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId",
    element: <BuildProjectDetailPage />,
  },

  // ── Project Member ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId/members",
    element: <BuildProjectMemberListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId/members/assign",
    element: <BuildProjectMemberAssignPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId/members/:memberId",
    element: <BuildProjectMemberDetailPage />,
  },

  // ── Program ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/programs",
    element: <BuildProgramListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/programs/:programId",
    element: <BuildProgramDetailPage />,
  },

  // ── Project GoalAchievement ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/projects/:projectId/goal-achievements",
    element: <BuildProjectGoalAchievementListPage />,
  },

  // ── Program Member ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/programs/:programId/members",
    element: <BuildProgramMemberListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/programs/:programId/members/assign",
    element: <BuildProgramMemberAssignPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/programs/:programId/members/:memberId",
    element: <BuildProgramMemberDetailPage />,
  },

  // ── Program GoalAchievement ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/programs/:programId/goal-achievements",
    element: <BuildProgramGoalAchievementListPage />,
  },

  // ── Department ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments",
    element: <BuildDepartmentListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId",
    element: <BuildDepartmentDetailPage />,
  },

  // ── Department Member ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/members",
    element: <BuildDepartmentMemberListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/members/assign",
    element: <BuildDepartmentMemberAssignPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/members/:memberId",
    element: <BuildDepartmentMemberDetailPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/members/move/company",
    element: <BuildDepartmentMemberMoveCompanyPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/members/move/market",
    element: <BuildDepartmentMemberMoveMarketPage />,
  },

  // ── Department Application ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/applications",
    element: <BuildDepartmentApplicationListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/applications/assign",
    element: <BuildDepartmentApplicationAssignPage />,
  },

  // ── Department Partner ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/partners",
    element: <BuildDepartmentPartnerListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/partners/assign",
    element: <BuildDepartmentPartnerAssignPage />,
  },

  // ── Department Action ──
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/actions",
    element: <BuildDepartmentActionListPage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/actions/create",
    element: <BuildDepartmentActionCreatePage />,
  },
  {
    path: ":businessDomainId/business-units/:businessUnitId/departments/:departmentId/actions/:actionId",
    element: <BuildDepartmentActionDetailPage />,
  },
];

export default buildRoutes;
